/**
 * Hook to detect if the app is running in demo mode.
 * Demo mode is activated by the ?demo=true URL parameter.
 * The parameter persists naturally across SPA navigation.
 */
export function useDemoMode(): boolean {
  return new URLSearchParams(window.location.search).get("demo") === "true";
}
